
import mutations from '../../general/mutations';
import currentMutations from './mutations';
import { DataService } from '../../../../src/config/dataService/dataService';


const state = () => ({
    list: [],
    currentHomeVideo: {},
    loading: false,
    message: '',
});
// declare actions
const actions = {

    async getHomeVideo({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Home/GetHomeVideo`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_HOME_VIDEOS', response.data.data);
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateHomeVideo({ commit },dataToSend) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/UpdateHomeVideo`,dataToSend);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    
    async setHomeVideo({ commit }, homeVideo) {
        try {
            await commit('SET_HOME_VIDEOS', homeVideo);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async storeCurrentHomeVideoToView({ commit },partner) {
        await commit('axiosStart');
        await commit('SET_CURRENT_HOME_VIDEO',partner);
        await commit('axiosSuccess');
        return true
    },
    
    //HOME FACTS
    async getAllFacts({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Home/GetHomeFacts`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_FACTS', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    async setFacts({ commit }, facts) {
        try {
            await commit('SET_FACTS', facts);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async addFact({ commit }, fact) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/AddFact`, fact);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateFact({ commit }, fact) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/UpdateFact`, fact);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    
    
    async storeCurrentFactToView({ commit },fact) {
        await commit('axiosStart');
        await commit('SET_CURRENT_FACT',fact);
        await commit('axiosSuccess');
        return true
    },
    //HOME TESTIMONIALS
    async getAllTestimonials({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Home/GetAllTestimonials`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_TESTIMONIALS', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    

    async changeTestimonialStatus({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/ChangeTestimonialStatus`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async setTestimonials({ commit }, testimonials) {
        try {
            await commit('SET_TESTIMONIALS', testimonials);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async addTestimonial({ commit }, testimonial) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/AddTestimonial`, testimonial);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateTestimonial({ commit }, testimonial) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/UpdateTestimonial`, testimonial);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async storeCurrentTestimonialToView({ commit },testimonial) {
        await commit('axiosStart');
        await commit('SET_CURRENT_TESTIMONIAL',testimonial);
        await commit('axiosSuccess');
        return true
    },
    //HOME QUOTES
    async getAllQuotes({ commit }) {
        try {
            await commit('axiosStart');
            const response = await DataService.get(`/Home/GetAllQuotes`);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                await commit('SET_QUOTES', response.data.data);
                return response.data
            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async changeQuoteStatus({ commit }, value) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/ChangeQuoteStatus`,{},{
                id:value.id
            });
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },

    async setQuotes({ commit }, quotes) {
        try {
            await commit('SET_QUOTES', quotes);
            return true
        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async addQuote({ commit }, quote) {
        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/AddQuote`, quote);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },
    async updateQuote({ commit }, quote) {

        try {
            await commit('axiosStart');
            const response = await DataService.post(`/Home/UpdateQuote`, quote);
            if (response.data.status == 1) {
                await commit('axiosSuccess');
                return response
                //send back the token

            } else {
                await commit('axiosSuccess');
                return false
            }

        } catch (err) {
            await commit('axiosError', err);
            return false;
        }
    },


    async storeCurrentQuoteToView({ commit },quote) {
        await commit('axiosStart');
        await commit('SET_CURRENT_QUOTE',quote);
        await commit('axiosSuccess');
        return true
    },
    


};

export default {
    namespaced: false,
    state,
    actions,
    mutations: { ...currentMutations, ...mutations }
};
